import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';

export const Separator = styled.div`
  background-color: ${colors.stormGray};
  height: 0.0625rem;
`;
